/* v3 swap: the /insights/:id detail route now renders the v3 Insights
   reader (src/v2/v3/InsightReader.jsx) instead of the old violet
   AppLayout card. The reader brings its own v3 shell (TickerStrip +
   BottomNav), so the nav matches the rest of v3 (Overview / Signals /
   Market Map / My Stocks / More) instead of the old V2 nav.

   App.jsx still imports { V2InsightDetailPage } from here — only what it
   renders changed. */
import { InsightReader } from '@/v2/v3/InsightReader'

export function V2InsightDetailPage() {
  return <InsightReader />
}
